import { Card, Col, Row, Collapse, Alert, Button } from 'antd'
import Avatar from 'antd/lib/avatar';
import React, { useEffect, useState } from 'react'
import { translate } from 'react-i18next';
import { useSelector } from 'react-redux';
import { get, isEmpty, isNull, isUndefined } from 'lodash';
import { IconHelper, routersHelper } from '../../helpers';
import PopupCancelMemberShip from '../../helpers/PopupCancelMemberShip'
import jwt_decode from "jwt-decode";
import MyRecordSummary from './MyRecordSummary';
import analytics from '../../libs/analytics'
import moment from 'moment';
import queryString from "query-string"


const ProfileInfo = ({ t, keycloak }) => {
    const language = localStorage.getItem('i18nextLng')
    const { useRouter } = routersHelper
    const router = useRouter()
    const parsed = queryString.parse(router.location.search);
    const [showAlert, setshowAlert] = useState(false)
    const [text, settext] = useState('')
    const [paymentErr, setpaymentErr] = useState(false)
    const [cancelPending, setcancelPending] = useState(false)
    const [imgProfile, setimgProfile] = useState('')
    const [paid, setpaid] = useState(false)
    const [Iscancel, setIscancel] = useState(false)
    const [packageName, setpackageName] = useState('')
    const [showCancel, setshowCancel] = useState(false)
    const [name, setName] = useState({
        familyName: '',
        givenName: ''
    })
    const contextInfo = useSelector(state => state.contextInfo)
    const packageLists = useSelector(state => state.packageLists)
    const lang = useSelector(state => state.language)
    const userProfileHistory = useSelector(state => state.userProfileHistory)
    const paymentHistoryList = useSelector(state => state.paymentHistory.paymentHistoryList)
    let dueDate = ''

    if (paymentHistoryList.length > 0) {
        const filterPaidStatus = paymentHistoryList.filter((e) => e.status === "paid");
        const lastPayment = filterPaidStatus[0].chargeNotifyRequest['subscription-result'].data['next-cycle-date']
        dueDate = moment(lastPayment).add(language === 'th' ? 543 : 0, "year").format('DD/MM/YYYY')
    }

    const gridStyle = {
        width: '100%',
    };

    const { IconEditProfile, IconBoxTrueVroom } = IconHelper

    const { Panel } = Collapse;

    useEffect(() => {
        document.body.style.setProperty("background", "#fff", "important")
    })

    useEffect(() => {
        const { nextCycleDate, recurringStatus, expireDate, packageType } = userProfileHistory

        if (!isEmpty(paymentHistoryList) && paymentHistoryList.length > 0) {
            setpaid(true)
        } else {
            setpaid(false)
        }

        if (paid) {
            const sysDate = Date.parse(new Date())
            if (!isNull(nextCycleDate)) {
                if (sysDate > Date.parse(new Date(nextCycleDate))) {
                    setpaymentErr(true)
                    setshowAlert(true)
                    settext(t('user_profile.warning.text_1'))
                }
            } else {
                if (!isNull(expireDate) && (sysDate > Date.parse(new Date(expireDate)))) {
                    setpaymentErr(true)
                    setshowAlert(true)
                    settext(t('user_profile.warning.text_1'))
                }
            }

            if (recurringStatus === "cancel") {
                setcancelPending(true)
                setshowAlert(true)
                settext(t('user_profile.warning.text_2'))
            }
        }

        if (!isUndefined(userProfileHistory.currentPackage.description) && !parsed.packageName) {

            setpackageName(userProfileHistory.currentPackage.description[lang].packageName)

        } else if ( !isUndefined(userProfileHistory.currentPackage.description) && parsed.packageName ) {

            if(packageLists.packages.length > 0) {
                const findCurrent = packageLists.packages.filter(packages => packages.description[lang].packageName === parsed.packageName)
                
                if(findCurrent.length === 0 || userProfileHistory.currentPackage.description[lang].packageName !== findCurrent[0].description[lang].packageName) {
                    window.location.href = '/portal/profile?k='+ new Date().getTime()
                }
                
                setpackageName(userProfileHistory.currentPackage.description[lang].packageName)
            }
        }

        if (isNull(expireDate) && packageType === "payment") {
            setshowCancel(true)
        }

    }, [contextInfo.email, paymentErr, cancelPending, paid, t, paymentHistoryList, lang, userProfileHistory, packageLists, parsed.packageName])

    useEffect(() => {
        if (!isEmpty(keycloak.idToken)) {
            const { idToken } = keycloak
            const jwtDecode = jwt_decode(idToken)
            setName({
                familyName: jwtDecode.family_name,
                givenName: jwtDecode.given_name
            })
        }
    }, [keycloak])

    useEffect(() => {
        const testImage = (URL) => {
            if (!isEmpty(URL)) {
                var tester = new Image();
                tester.onload = imageFound;
                // tester.onerror = imageNotFound;
                tester.src = URL;
            }
        }

        const imageFound = () => {
            setimgProfile(contextInfo.avatar)
        }

        // const imageNotFound = () => {
        //     setimgProfile('')
        // }

        testImage(contextInfo.avatar)

    }, [contextInfo.avatar])


    const handlePaymentBtn = () => {
        router.push('/portal/paymentHistory')
    }

    const handleCancelBtn = () => {
        analytics.sendEvent({
            category: 'Plan & Pricing',
            action: 'PlanAndPricing-Cancel-Button-Clicked',
        });
        setIscancel(true)
    }

    const handleCancelPanel = (key) => {
        if (key.includes("2")) {
            const element = document.getElementById("panel-cancel")
            if (element.getElementsByClassName("ant-collapse-header")[0]) {
                element.getElementsByClassName("ant-collapse-header")[0].style.backgroundColor = '#F2F2F2';
            }
        } else {
            const element = document.getElementById("panel-cancel")
            if (!isNull(element)) {
                if (element.getElementsByClassName("ant-collapse-header")[0]) {
                    element.getElementsByClassName("ant-collapse-header")[0].style.backgroundColor = '#fff';
                }
            }
        }
    }

    const handleBtnGotoProfile = () => {
        router.push('/portal/profile/edit')
    }

    const currentPackage = userProfileHistory.currentPackage

    return (
        <>
            <Row>
                <Col
                    // span={10}
                    sm={{ span: 20, offset: 2 }}
                    xs={{ span: 20, offset: 2 }}
                    md={{ span: 10, offset: 7 }}
                    lg={{ span: 10, offset: 7 }}
                // offset={7}
                >
                    <Card className="user-profile" title={t('user_profile.header')} >
                        <Card.Grid style={gridStyle} hoverable={false}>
                            <Row style={{ width: '108%', marginLeft: '-4%' }} className="user-profile-box">
                                <Col
                                    // span={6}
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={8}
                                    className="user-profile-avatar"
                                >
                                    {
                                        imgProfile !== '' ? (
                                            <Avatar
                                                size={100}
                                                src={imgProfile}
                                            />
                                        ) : (
                                            <div className="icon-no-img">
                                                <IconEditProfile />
                                            </div>
                                        )
                                    }

                                </Col>
                                <Col
                                    // span18}
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={16}
                                    className="user-profile-info"
                                >
                                    <Row>
                                        <Col
                                            span={5}
                                        >
                                            <p className="info-main">{t('user_profile.display_name')}</p>
                                        </Col>
                                        <Col
                                            span={19}
                                        >
                                            <p className="info-detail">{contextInfo.name}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col
                                            span={5}
                                        >
                                            <p className="info-main">{t('user_profile.email')}</p>
                                        </Col>
                                        <Col
                                            span={19}
                                        >
                                            <p className="info-detail">{contextInfo.email}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col
                                            span={5}
                                        >
                                            <p className="info-main">{t('user_profile.name')}</p>
                                        </Col>
                                        <Col
                                            span={19}
                                        >
                                            <p className="info-detail">{name.givenName}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col
                                            span={5}
                                        >
                                            <p className="info-main">{t('user_profile.surname')}</p>
                                        </Col>
                                        <Col
                                            span={19}
                                        >
                                            <p className="info-detail">{name.familyName}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Button onClick={handleBtnGotoProfile} className="btn-go-to-edit-user" danger>{t('edit_profile.edit_profile_btn')}</Button>
                            </Row>
                        </Card.Grid>
                        <Card.Grid style={gridStyle} hoverable={false}>
                            <p className="package-text">
                                {t('user_profile.packpage')}
                            </p>
                            {
                                paid ? (
                                    <Row className="box-alert">
                                        <Col
                                            span={24}
                                        >
                                            {
                                                showAlert ? (
                                                    <Alert
                                                        description={text}
                                                        type="warning"
                                                        showIcon
                                                    />
                                                ) : null
                                            }
                                            <Collapse
                                                defaultActiveKey="1"
                                                expandIconPosition="right"
                                                onChange={handleCancelPanel}
                                            >
                                                <Panel
                                                    id="panel-personal"
                                                    header={packageName}
                                                    key="1"
                                                    extra={<Button onClick={handlePaymentBtn} className="payment-history-btn">{t('user_profile.collpase.text_1_btn')}</Button>}
                                                    showArrow={false}
                                                >
                                                </Panel>
                                                {
                                                    showCancel ? (
                                                        <Panel
                                                            header={t('user_profile.collpase.text_2')} key="2"
                                                            id="panel-cancel"
                                                        >
                                                            <span>{t('user_profile.collpase.text_2')}</span>
                                                            <Button onClick={handleCancelBtn} className="cancel-membership-btn" style={{ float: 'right' }}>{t('user_profile.collpase.text_2_btn')}</Button>
                                                        </Panel>
                                                    ) : null
                                                }
                                            </Collapse>
                                        </Col>
                                    </Row>
                                ) : (
                                    <div className="package-info">
                                        {packageName}
                                    </div>
                                )
                            }
                            <Row className="package-detail">
                                <Col lg={5} sm={6}>
                                    <IconBoxTrueVroom />
                                </Col>
                                <Col lg={19} sm={18}>
                                    <h3 className="red">{get(currentPackage, `description.${lang}.packageName`, '')}</h3>
                                    <span>
                                        <strong>
                                            <label dangerouslySetInnerHTML={{ __html: get(currentPackage, `description.${lang}.feature[0].header`, '') }} />
                                        </strong>
                                        &nbsp;:&nbsp;
                                        <label dangerouslySetInnerHTML={{ __html: get(currentPackage, `description.${lang}.feature[0].body`, '') }} />
                                    </span><br />
                                    <span>
                                        <strong>
                                            <label dangerouslySetInnerHTML={{ __html: get(currentPackage, `description.${lang}.feature[1].header`, '') }} />
                                        </strong>
                                        &nbsp;:&nbsp;
                                        <label dangerouslySetInnerHTML={{ __html: get(currentPackage, `description.${lang}.feature[1].body`, '') }} />
                                    </span>
                                    <div id="hr" />
                                    <h3 className="red">{get(currentPackage, `description.${lang}.feature[2].header`, '')}</h3>
                                    <div dangerouslySetInnerHTML={{ __html: get(currentPackage, `description.${lang}.feature[2].body`, '') }} />
                                </Col>
                            </Row>
                            <MyRecordSummary />
                        </Card.Grid>
                    </Card>
                </Col>
            </Row>
            <PopupCancelMemberShip visible={Iscancel} setVisible={setIscancel} dueDate={dueDate} />
        </>
    )
}

export default translate()(ProfileInfo)
